"use client";

import { useToast } from "@/components/ui/use-toast";
import { allowedFormats } from "@/constant"; 
import { ChangeEventHandler, useRef } from "react";
import { IoAlertCircleOutline } from "react-icons/io5";

interface TypeUploadingComponent {
  handleSetFile: (name: string, value: File | null) => void;
  label: string;
  currentFile: { file: File | null; deletable: boolean };
}

export default function UploadingCom(props: TypeUploadingComponent) {
  const { label, handleSetFile, currentFile } = props;
  const { toast } = useToast();

  const handleFileSelect: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (allowedFormats.includes(file.type)) {
        handleSetFile(label, file);
      } else {
        toast({
          title: "فرمت های مجاز zip,pdf,png,jpg,jpeg,gif,rar !",
          variant: "error",
        });
        handleSetFile(label, null);
      }
    }
  };

  const formRef = useRef<HTMLFormElement>(null);

  return (
    <div className="flex flex-col lg:flex-row gap-5 justify-center items-center">
      <div 
        className="md:!justify-center justify-start items-start md:!gap-1 gap-2 flex md:!flex-row flex-col"
      >
        <form ref={formRef}>
          <div
            dir="rtl"
            className="flex w-full sm:!w-[15rem] flex_col gap-1 mb-2 flex-col"
          >
            <label className="text-sm text-black">
              {`فایل  ${label} *`}
            </label>
            <div className="border-[1px] p-2 flex justify-start rounded-2xl items-center gap-2">
              <input
                dir="ltr"
                className={`${styleInputFile} hidden`}
                id={`file-input-${label}`}
                type="file"
                multiple={false}
                onChange={handleFileSelect}
                name={label}
                accept={
                  "image/*,application/zip,application/x-zip,application/x-zip-compressed"
                }
              />
              <label
                className="bg-blue text-white block p-1.5 !text-sm !rounded-xl cursor-pointer flex-shrink"
                htmlFor={`file-input-${label}`}
              >
                انتخاب فایل
              </label>
              <span className="truncate text-xs w-1/2">
                {currentFile.file?.name || label}
              </span>
            </div>
            <p  className="text-blue">
              <IoAlertCircleOutline className="i_f text-base mx-1" />
              فرمت های مجاز zip,pdf,png,jpg,jpeg,gif,rar
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

const styleInputFile =
  "w-full file:bg-btn file:py-1 file:px-2 file:border-none file:rounded-full py-1 block text-sm file:text-white border-none border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none dark:border-gray-600 text-black";
